import { Stepper as MuiStepper, StepperProps as MuiStepperProps } from '@mui/material';
import React from 'react';

export type StepperProps = MuiStepperProps;

export const Stepper = (props: StepperProps) => {
  return <MuiStepper {...props} />;
};
